export default {
  displayName: 'Basic Content',
  allowableParents: ['Section'],
};
